module.exports = __webpack_public_path__ + "static/img/businessUser_active.9a2ae360.svg";